document.addEventListener('DOMContentLoaded', function () {

  function initFreeGiftButtons() {

    const buttons = document.querySelectorAll(
      '.product-promotion__gift-button'
    );

    buttons.forEach(function (button) {

      if (button.dataset.initialized === 'true') {
        return;
      }

      button.dataset.initialized = 'true';

      button.addEventListener('click', async function () {

        const giftVariantId = this.dataset.giftVariantId;

        if (!giftVariantId) {
          console.error('Free Gift variant ID not found.');
          return;
        }

        const buttonText = this.querySelector(
          '.product-promotion__gift-button-text'
        );

        const buttonLoading = this.querySelector(
          '.product-promotion__gift-button-loading'
        );

        this.disabled = true;
        this.classList.add('loading');

        if (buttonText) {
          buttonText.style.display = 'none';
        }

        if (buttonLoading) {
          buttonLoading.style.display = 'inline';
        }

        try {

          /*
           * Add Free Gift to cart
           */
          const response = await fetch(
            window.Shopify.routes.root + 'cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(giftVariantId),
                    quantity: 1
                  }
                ]
              })
            }
          );

          const result = await response.json();

          if (!response.ok) {
            throw new Error(
              result.description || 'Unable to add Free Gift.'
            );
          }

          /*
           * Refresh Cart Drawer
           */
          await refreshCartDrawer();

        } catch (error) {

          console.error('Free Gift Error:', error);

          alert(
            error.message || 'ไม่สามารถเพิ่ม Free Gift ได้'
          );

        } finally {

          this.disabled = false;
          this.classList.remove('loading');

          if (buttonText) {
            buttonText.style.display = 'inline';
          }

          if (buttonLoading) {
            buttonLoading.style.display = 'none';
          }

        }

      });

    });

  }


  async function refreshCartDrawer() {

    const cartDrawer = document.querySelector('cart-drawer');

    /*
     * If Cart Drawer doesn't exist,
     * simply reload the page.
     */
    if (!cartDrawer) {
      window.location.reload();
      return;
    }

    try {

      const response = await fetch(
        window.Shopify.routes.root +
        '?sections=cart-drawer,cart-icon-bubble'
      );

      const sections = await response.json();

      /*
       * Use existing CartDrawer renderContents()
       * from your theme's cart-drawer.js
       */
      if (typeof cartDrawer.renderContents === 'function') {

        cartDrawer.renderContents({
          sections: sections,
          item_count: 0
        });

      } else {

        window.location.reload();

      }

    } catch (error) {

      console.error(
        'Unable to refresh cart drawer:',
        error
      );

      window.location.reload();

    }

  }


  /*
   * Initial load
   */
  initFreeGiftButtons();


  /*
   * Re-initialize if Shopify/theme
   * dynamically changes the product section.
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      initFreeGiftButtons();
    }
  );

});